export default __webpack_public_path__ + "static/media/roboto-v27-latin-regular.4673b453.woff2";